import { memo } from "react";
import { useSelector } from "react-redux";
import { selectSmartLink } from "@/store/slices/smartLink/smartLinkSlice";

/**
 * Read-only affordance shown while viewing someone else's shared smart-link
 * selection. Presentational only -- no persistence controls. Segment edits
 * made during the session stay local and are never written to the
 * recipient's account (see the session branch of `setSegmentApplied` in
 * `segments.thunk.ts`).
 */
export const SharedSelectionBanner = memo(function SharedSelectionBanner() {
  const { active, origin } = useSelector(selectSmartLink);
  // A saved view the caller opened is not someone else's selection; the session
  // still runs, but claiming it is shared would be false.
  if (!active || origin === "view") return null;

  return (
    <span
      role="status"
      className="inline-flex h-[26px] items-center gap-1.5 rounded-full bg-primary-soft px-2.5 text-xs font-medium text-primary-500"
    >
      Viewing a shared selection
    </span>
  );
});

export default SharedSelectionBanner;
